import React from 'react';
import { CompactError, RobbiePopup } from '../ui';
import { ShortlistSaveState } from '../../hooks/useShortlistSelection';

interface ShortlistSavePopupProps {
  state: ShortlistSaveState;
  picks: number;
  onRetry: () => void;
  onClose: () => void;
}

const picksText = (n: number) => `${n} pick${n === 1 ? '' : 's'}`;

/** The quick save before outreach: a small Robbie pop-up, or its error with the picks kept. */
export const ShortlistSavePopup: React.FC<ShortlistSavePopupProps> = ({ state, picks, onRetry, onClose }) => {
  if (state === 'failed') {
    return (
      <div className="fixed inset-0 z-[80] flex items-center justify-center bg-chrome/40 p-s7" role="dialog" aria-modal="true">
        <div className="w-full max-w-[374px] rounded-[16px] bg-surface px-s7 pb-[22px] pt-s7 shadow-floating">
          <CompactError
            title="Couldn't save your picks"
            message={`Your ${picksText(picks)} are still selected.`}
            action={{ label: 'Try again', onClick: onRetry }}
            secondaryAction={{ label: 'Close', onClick: onClose }}
          />
        </div>
      </div>
    );
  }
  return (
    <RobbiePopup open={state === 'saving'} size="small" title={`Saving your ${picksText(picks)}`} />
  );
};

export default ShortlistSavePopup;
